export const override = (theme) => {
  return Object.assign({}, theme, {
    overrides: {
      MuiInput: {
        underline: {
          '&:after': {
            borderBottom: `thin solid ${theme.palette.secondary.light}`
          },
          '&:before': {
            height: '0',
            borderBottom: 'thin solid rgba(0, 0, 0, 0.42)'
          },
          '&:hover:not($disabled):before': {
            height: 0
          },
          '&$disabled:before': {
            backgroundSize: 'auto',
            borderBottom: 'thin dashed rgba(0, 0, 0, 0.42)'
          }
        }
      },
      MuiSvgIcon: {
        root: {
          height: 24,
          width: 24
        }
      },
      MuiButton: {
        text: {
          padding: '6px 16px'
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/themes/override/index.ts